import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { NonceService } from "./nonce.service";

@Injectable({
    providedIn: 'root',
})
export class StyleNonceService {
    private readonly renderer: Renderer2;

    constructor(private readonly rendererFactory: RendererFactory2, private readonly nonceService: NonceService) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    applyNonceToStyles(): void {
        const styles = document.querySelectorAll('style');
        styles.forEach((style) => {
            if (!style.getAttribute('nonce')) {
                this.renderer.setAttribute(style, 'nonce', this.nonceService.nonce);
            }
        })
    }
}